@if (loading) {
  <kendo-loader type="converging-spinner" size="large"></kendo-loader>
}

<kendo-grid [data]="reports" scrollable="none" [hidden]="loading">
  <ng-template kendoGridToolbarTemplate>
    <label class="font-weight-bold">Scenario Reports</label>
  </ng-template>

  <kendo-grid-column title="Name">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span>
        <a [href]="dataItem.URL" target="_blank">{{ dataItem.Name }}</a>
      </span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Description">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span>
        <a [href]="dataItem.URL" target="_blank">{{ dataItem.Description }}</a>
      </span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Operational">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span>{{ dataItem.IsOperational ? 'Yes' : 'No' }}</span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Function">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span>{{ dataItem.Func }}</span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Type">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span>{{ dataItem.Type }}</span>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>